import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularPickUpsBetweenDateController, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { FollicularPickUpsBetweenDateRequest } from '../../../../../../../src/app/ncs/models/actor/actor';



@Component({
  selector: 'pickupdetails',
  templateUrl: './pickupdetails.component.html',
  styleUrls: ['./pickupdetails.component.scss']
})

export class PickupdetailsPVComponent implements OnInit {


  public Date: Date;
  currentPage: string = "About"
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  //OvulationTriggerDate: NgbDateStruct;
  //OvumPickupdate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  //ActualPickupDate: NgbDateStruct;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;
  public Owner: string;
  public PatientID: string;
  public Protocolst: string;
  public ProtocolEd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public CycleType: string;
  public OvulationTriggerDate: string;
  public OvulationTriggerTime: string;
  public MedicineName: string;
  public Dosage: string;
  public SurgeonName: string;
  public AsstSurgeonName: string;
  public FpSign1: string;
  public FpSign2: string;
  public AnaesthesiaType: string;
  public AnesthesiologistName: string;
  public NeedleUsed: string;
  public Route: string;
  public Complications: string;
  public MinPickupSize: string;
  public PickupSizeUnits: string;
  public OvumPlannedPickupDate: string;
  public OvumPickupdate: string;
  public OvumPickupTime: string;
  public RFollicleCount: string;
  public LFollicleCount: string;
  public RFollicleAspirated: string;
  public LFollicleAspirated: string;
  public TotalRtOocytes: string;
  public TotalLtOocytes: string;
  public TotalOocytes: string;
  public DSADOC: string;
  public DSASTIMULATION: string;
  public DSAANTAG: string;

  public triggertype: string;
  public ExpiryDate: string;
  public OvulationTriggerTime2: string;
  public OvulationTriggerDate2: string; 
  public MedicineName2: string;
  public Dosage2: string;
  public ExpiryDate2: string;
  public EggSourceData: string;
  public DonorData: string;
  public DonorCode: string;


  //public Code: number;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public Showpickup: boolean = true;
  public Showivf: boolean = false;

  //public OvulationTriggerTime: any;
  //
  public SelectedReport: string;
  public SelectedActorCode: number = 92;
  //public IvfCycleFolliculePickupCode: any;
  public Pickup: any;
  public PickUpCode: any;
  public CycleCode: any;
  public FollicularGrowthCode: any;
  //public PickUpCode: any;
  PatientCode: any;
  public ActivityCode: any;
  //onDataReady() {
  //  setTimeout(() => {
  //    window.print();
  //    this.isPrinting = true;
  //    this.router.navigate([{ outlets: { print: null } }]);
  //  });
  //}
  //isPrinting = false;

  time: number;

  CurrentFollicularScanOvaryDetailController: FollicularScanOvaryDetailController[];
  EndometriumthicknessData: FollicularScanOvaryDetailController;
  CurrentFollicularScanOvaryDetailRequest: FollicularScanOvaryDetailRequest;

  LoadOvaryData() {
    //alert("ScansData")
    this.CurrentFollicularScanOvaryDetailRequest = new FollicularScanOvaryDetailRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    //this.PickUpCode = this.route.snapshot.paramMap.get('PickupCodeData');
    this.CycleCode = this.route.snapshot.paramMap.get('CycleCodeData');
    this.PatientCode = this.route.snapshot.paramMap.get('ActorCodeData');
    this.FollicularGrowthCode = this.route.snapshot.paramMap.get('FollicularGrowthCodeData');
    this.CurrentFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularScanOvaryDetailController();
  }

  GetFollicularScanOvaryDetailController() {
    this.StartRefreshing();

    //this.CurrentFollicularScanOvaryDetailRequest.ScanCode = this.PickUpCode;
    this.CurrentFollicularScanOvaryDetailRequest.CycleCode = this.CycleCode;
    this.CurrentFollicularScanOvaryDetailRequest.PatientCode = this.PatientCode;
    this.CurrentFollicularScanOvaryDetailRequest.ScanCode = this.FollicularGrowthCode;
    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScanOvaryDetailController(this.CurrentFollicularScanOvaryDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScanOvaryDetailController = this.ApiResData.Result;
          this.EndometriumthicknessData = this.CurrentFollicularScanOvaryDetailController[0];
          //this.LeftOvaries = this.CurrentFollicularScanOvaryDetailController[5].Size;
          //this.RightOvaries = this.CurrentFollicularScanOvaryDetailController[1].Size;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadMedicineData();          
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

  LoadTestData() {
    //alert("ScansData")
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CycleCode = this.route.snapshot.paramMap.get('CycleCodeData');
    this.ActivityCode = this.route.snapshot.paramMap.get('ActivityCodeData');
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
      this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.ActivityCode;
      this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
      this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
    //this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.SelectedpatientDetails.PickUpTreatmentCycle;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.PickUpCycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadOvaryData();
          //   this.LoadGuardian();
          //this.LoadMessages();          

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
  CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

  LoadMedicineData() {
    //alert("ScansData")
    this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CycleCode = this.route.snapshot.paramMap.get('CycleCodeData');
    this.ActivityCode = this.route.snapshot.paramMap.get('ActivityCodeData');
    this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleMedicineByCodeController();
  }

  GetIvfCycleMedicineByCodeController() {
    this.StartRefreshing();

    this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
      this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.ActivityCode;
      this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
      this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;    
    //this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.SelectedpatientDetails.PickUpTreatmentCycle;
    ////this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.SelectedpatientDetails.PickUpCycleActivity;
    ////alert(this.FormattedCode);
    this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadOvariesData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentFollicularPickUpsByCodeController: FollicularPickUpsByCodeController[];
  //FollicularPickupEndInfo: FollicularPickUpsByCodeController;
  CurrentFollicularPickUpsByCodeRequest: FollicularPickUpsByCodeRequest;

  LoadOvariesData() {
    //alert("ScansData")
    this.CurrentFollicularPickUpsByCodeRequest = new FollicularPickUpsByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.PickUpCode = this.route.snapshot.paramMap.get('PickupCodeData');
    this.CurrentFollicularPickUpsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularPickUpsByCodeController();
  }

  GetFollicularPickUpsByCodeController() {
    this.StartRefreshing();
    this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.PickUpCode;
    //this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.SelectedpatientDetails.PickUpCode;
    //this.CurrentFollicularPickUpsDetailRequest.CycleActivity = this.SelectedpatientDetails.PickUpCycleActivity;
    //this.CurrentFollicularPickUpsDetailRequest.TreatmentCycle = this.SelectedpatientDetails.PickUpTreatmentCycle;
    //this.CurrentFollicularPickUpsDetailRequest.FollicularPickup = this.SelectedpatientDetails.PickUpCode;
    //this.CurrentFollicularPickUpsDetailRequest.OvumPlannedPickupDate = this.SelectedpatientDetails.OvumPlannedPickupDate;
    //this.CurrentFollicularPickUpsDetailRequest.ActorCode = this.SelectedpatientDetails.ActorCode;
    //alert(this.FormattedCode);
    this.actorservice.GetFollicularPickUpsByCodeController(this.CurrentFollicularPickUpsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularPickUpsByCodeController = this.ApiResData.Result;
          //this.FollicularPickupEndInfo = this.CurrentFollicularPickUpsByCodeController[0];
          //if (this.FollicularPickupEndInfo.OvulationTriggerDate != null) {
          //  var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.OvulationTriggerDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //if (this.FollicularPickupEndInfo.OvumPickupdate != null) {
          //  var SValidFrom = new Date(this.FollicularPickupEndInfo.OvumPickupdate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.OvumPickupdate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.printService.onDataReady()
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }

  public AsstSurgeon: string;
  ngOnInit() {
    this.Date = new Date();
    //this.Code = this.route.snapshot.paramMap.get('Code');
    //alert(this.Code);
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    //this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
    //this.LoadPatients();
    this.AsstSurgeon = AppData.Instance().cas.AsstSurgeon;
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.PatientID = this.route.snapshot.paramMap.get('PatientID');
    this.Protocolst = this.route.snapshot.paramMap.get('Protocolst');
    this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.OvulationTriggerDate = this.route.snapshot.paramMap.get('OvulationTriggerDate');
    this.OvulationTriggerTime = this.route.snapshot.paramMap.get('OvulationTriggerTime');
    this.MedicineName = this.route.snapshot.paramMap.get('MedicineName');
    this.Dosage = this.route.snapshot.paramMap.get('Dosage');
    this.SurgeonName = this.route.snapshot.paramMap.get('SurgeonName');
    this.AsstSurgeonName = this.route.snapshot.paramMap.get('AsstSurgeonName');
    this.FpSign1 = this.route.snapshot.paramMap.get('SurgeonName');
    this.FpSign2 = this.route.snapshot.paramMap.get('AsstSurgeonName');
    this.AnaesthesiaType = this.route.snapshot.paramMap.get('AnaesthesiaType');
    this.AnesthesiologistName = this.route.snapshot.paramMap.get('AnesthesiologistName');
    this.NeedleUsed = this.route.snapshot.paramMap.get('NeedleUsed');
    this.Route = this.route.snapshot.paramMap.get('Route');
    this.Complications = this.route.snapshot.paramMap.get('Complications');
    this.MinPickupSize = this.route.snapshot.paramMap.get('MinPickupSize');
    this.PickupSizeUnits = this.route.snapshot.paramMap.get('PickupSizeUnits');
    this.OvumPlannedPickupDate = this.route.snapshot.paramMap.get('OvumPlannedPickupDate');
    this.OvumPickupdate = this.route.snapshot.paramMap.get('OvumPickupdate');
    this.OvumPickupTime = this.route.snapshot.paramMap.get('OvumPickupTime');
    this.RFollicleCount = this.route.snapshot.paramMap.get('RFollicleCount');
    this.LFollicleCount = this.route.snapshot.paramMap.get('LFollicleCount');
    this.RFollicleAspirated = this.route.snapshot.paramMap.get('RFollicleAspirated');
    this.LFollicleAspirated = this.route.snapshot.paramMap.get('LFollicleAspirated');
    this.TotalRtOocytes = this.route.snapshot.paramMap.get('TotalRtOocytes');
    this.TotalLtOocytes = this.route.snapshot.paramMap.get('TotalLtOocytes');
    this.TotalOocytes = this.route.snapshot.paramMap.get('TotalOocytes');
    this.DSADOC = this.route.snapshot.paramMap.get('DSADOC');
    this.DSASTIMULATION = this.route.snapshot.paramMap.get('DSASTIMULATION');
    this.DSAANTAG = this.route.snapshot.paramMap.get('DSAANTAG');

    this.triggertype = this.route.snapshot.paramMap.get('triggertype');
    this.ExpiryDate = this.route.snapshot.paramMap.get('ExpiryDate');
    this.OvulationTriggerTime2 = this.route.snapshot.paramMap.get('OvulationTriggerTime2');
    this.OvulationTriggerDate2 = this.route.snapshot.paramMap.get('OvulationTriggerDate2');
    this.MedicineName2 = this.route.snapshot.paramMap.get('MedicineName2');
    this.Dosage2 = this.route.snapshot.paramMap.get('Dosage2');
    this.ExpiryDate2 = this.route.snapshot.paramMap.get('ExpiryDate2');
    this.EggSourceData = this.route.snapshot.paramMap.get('EggSourceData');
    this.DonorData = this.route.snapshot.paramMap.get('DonorData');
    this.DonorCode = this.route.snapshot.paramMap.get('DonorCode');

    this.LoadTestData();
    
    ///this.LoadClinics();
    //this.LoadMessages();
    //this.PatientActorCode = this.ActorCode;
    //this.PatientCycleCode = this.CycleCode;

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








